import { MediaMatcher } from '@angular/cdk/layout';
import { CommonModule } from '@angular/common';
import { AfterContentInit, AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, signal, ViewChild } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { EventInteractionService } from '@mare-common/ngx-mare-common';
import { MareLoaderModule } from '@mare-common/ngx-mare-loader';
import { TranslateModule } from '@ngx-translate/core';
import { OrderService } from 'src/app/services/order.service';
import { CommonConfig } from 'src/app/shared/common-config/common-config';
import { SelfcaringOrdersComponent, SelfcaringOrdersData } from './components/selfcaring-orders/selfcaring-orders.component';
import { MatDialog } from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import { PromoMarketplaceComponent } from 'src/app/promo/promo-marketplace/promo-marketplace.component';
import { Router } from '@angular/router';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'app-section-orders',
  standalone: true,
  imports: [CommonModule,
    MatTableModule,
    MatExpansionModule,
    TranslateModule,
    MatCardModule,
    MatButtonModule,
    MareLoaderModule,
    MatFormFieldModule,
    MatInputModule,
    MatToolbarModule,
    MatIconModule,
    MatTooltipModule,
    PromoMarketplaceComponent
  ],
  templateUrl: './orders.component.html',
  styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit, OnDestroy, AfterContentInit, AfterViewInit {
  
  orders!: any[];
  @Input() company: any
  
  downloading$ = signal<boolean>(false);

  orderDataSource: MatTableDataSource<any> = new MatTableDataSource<any>([
  ])
  orderDisplayedColumns: string[] = ['orderNumber','orderDate', 'products', 'total', 'status', 'actions'];


  @ViewChild('orderTable') orderTable!: MatTable<any>;
  mobileQuery: MediaQueryList
  hasOrders: boolean = false;

  loader$ = signal<boolean>(false);

  actions = [
    {
      icon: 'shopping_cart_checkout',
      tooltip: 'Completa l\'ordine  ',
      label: 'Checkout',
      action: (element: any) => { this.goToProduct(element) },
      toshowFunction: (element: any) => { 
        if (element.status == 'in attesa') {
          if (element.orderItems && element.orderItems.length == 1) {
            return element.orderItems[0].externalUrl && element.orderItems[0].externalUrl.trim() != ''
          }
          return element.externalUrl && element.externalUrl.trim() != ''
        }
        return false 
      }
    },
    {
      icon: 'description',
      tooltip: 'Dettagli dell\'ordine  ',
      label: 'Ordine',
      action: (element: any) => { this.openOrderDetails(element) },
      toshowFunction: (element: any) => { 
        if(element.status.indexOf('complet') > -1 ) {
          return true 
        }
        return false 
      }
    },
    {
      icon: 'description',
      tooltip: 'Ordine annullato  ',
      label: 'Ordine annullato',
      action: (element: any) => { this.openOrderDetails(element) },
      toshowFunction: (element: any) => { 
        if(element.status.indexOf('cancell') > -1 ) {
          return true 
        }
        return false 
      }
    },
    {
      icon: 'file_download',
      tooltip: 'Scarica la fattura',
      label: 'Fattura',
      action: (element: any) => { this.downloadContract(element) },
      toshowFunction: (element: any) => { 
        if(element.status.indexOf('complet') > -1 && element.invoiceUrl ) {
          return element.invoiceUrl && element.invoiceUrl.trim() != '' 
        }
        return false 
      }

    },
    {
      icon: 'login',
      tooltip: 'Accedi alla app',
      label: 'Accedi',
      action: (element: any) => { this.goToProduct(element) },
      toshowFunction: (element: any) => { 
        if (element.status.indexOf('complet') > -1 ) {
          if (element.orderItems && element.orderItems.length == 1) {
            return element.orderItems[0].externalUrl && element.orderItems[0].externalUrl.trim() != ''
          }
          return element.externalUrl && element.externalUrl.trim() != ''
        }
        return false 
      }
    },
    {
      icon: 'file_download',
      tooltip: 'Scarica il Benchmark',
      label: 'Benchmark',
      action: (element: any) => {this.goToTool(element) },
      toshowFunction: (element: any) => { 
        if (element.status.indexOf('complet') > -1 ) {
          if (element.orderItems && Array.isArray(element.orderItems) &&  element.orderItems.length == 1) {
            return element.orderItems[0].sku.indexOf('report-digitale') > -1
          }
          return element.sku.indexOf('report-digitale') > -1
        }
        return false 
      }
    },
  ]

  @Output() onAction: EventEmitter<any> = new EventEmitter<any>();


  constructor(
    private orderService: OrderService,
    private commonConfig: CommonConfig,
    private media: MediaMatcher,
    private evenInteractionService: EventInteractionService,
    private dialog: MatDialog,
    private router: Router,
    private reportService: ReportService

  ) {
    this.mobileQuery = media.matchMedia('(max-width: ' + commonConfig.getMobileBreakpoint() + 'px)');
   }
  ngOnInit(): void {
    this.loader$.set(true);
    this.initOrders();
  }


  initOrders() {

    this.orderService.getOrders().then((res: {orders: any[], convertedOrders: any[]}) => {
      console.log('__init orders ________________', res);
      this.orders = res.orders;
      if(res.convertedOrders.length > 0) {
        this.hasOrders = true;
        res.convertedOrders.forEach((order: any) => {
          this.orderDataSource.data.push(order);
        })
      } else {
        this.hasOrders = false;
      }
      this.render();
    }).finally(() => {
      this.loader$.set(false);
    })
  }

  ngAfterContentInit() {
    this.render();
  }

  ngAfterViewInit() {
    this.render();
  }

  render() {
    if (this.orders && this.orderTable) {
      this.orderTable.renderRows();
    }
  }

  ngOnDestroy(): void {
    this.orders = [];
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.orderDataSource.filter = filterValue.trim().toLowerCase();
  }

  downloadContract(element: any) {
    throw new Error('Method not implemented.');
  }
  openOrderDetails(element: any) {
    console.log(element);
    
    let orderId = element.orderNumber;
    if (!orderId) {
      return;
    }
    
    let dataOrder: SelfcaringOrdersData = {
      title: 'Ordine',
      orderElement: element.orderElement,
      orderType: element?.order_type,
      orderId: element?.orderNumber,
      orderRaw: element.orderRaw,
      orderDate: element?.orderDate,
      orderCompletion: element.status,
      orderItems: element?.orderItems,
      actions: []
    }
   
    const dialogRef = this.dialog.open(SelfcaringOrdersComponent, {
      width: '800px',
      maxWidth:'100vw', // 80vw',
      height: '100vh',
      maxHeight: '100vh',
      panelClass: 'modal-fixed-right',
      data: dataOrder
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed',result);
    })
  }
  goToProduct(element: any) {
    this.evenInteractionService.gotoLink(element.externalUrl, true)
  }
  goToTool(element: any) {
    this.downloading$.set(true);
    this.reportService.downloadReport(this.company.piva, true).then((res: any) => {
      this.downloading$.set(false);
    }).finally(() => {
      this.downloading$.set(false);
    })
    // this.onAction.emit({ event: 'gotoTool', element: element });
  }
}
